import { Button } from "@mui/material";
import styled from "styled-components";

const StyledButton = styled(Button)({
  color: "#FFFFFF",
  backgroundColor: "#FC4C4C",
  textTransform: "none",
  width: "100%",
  height: "48px",
  borderRadius: "4px",
  transition: "background 0.5s, color 0.5s",
  fontSize: "18px",
  fontFamily: "Roobert",
  fontWeight: "600",
  lineHeight: "22px",
  wordWrap: "break-word",
  "&:hover": {
    backgroundColor: "#FEDBDB",
    color: "#fff",
  },
  // disabled
  "&:disabled": {
    backgroundColor: "#D1D4D6",
    color: "#9CA3A8",
  },
});

StyledButton.defaultProps = {
  disableRipple: true,
};

export default StyledButton;
